let _foxKitCustomCount = 0;
let _foxKitCustomIntervalId = null;


_foxKitCustomIntervalId = setInterval(() => {
   if(window?.FoxkitEvents){
    window?.FoxkitEvents?.subscribe(`ON_ITEM_ADDED`, async payload => {
        if(!payload?.properties?.['_FoxKit offer']) return; 
        const sections = payload?.sections;
        const newCartJson = await window.FoxKitV2.getCart();
        newCartJson.sections = sections
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: newCartJson });
    });
    clearInterval(_foxKitCustomIntervalId);
   }
   _foxKitCustomCount += 1;
   if (_foxKitCustomCount >= 5){
    clearInterval(_foxKitCustomIntervalId);
   }

}, 200)

